<template>
  <div style="width: 100%">
    <lefmodal
      height="auto"
      width="1000px"
      :scrollable="true"
      :adaptive="true"
      name="errocnae"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <p
          align="justify"
          style="color: #383838; margin: 25px; font-size: 20px"
          id="excecao"
        >
          Erro no CNAE, Tente novamente!
        </p>
      </div>
    </lefmodal>
    <lefmodal
      height="auto"
      width="1000px"
      :scrollable="true"
      :adaptive="true"
      name="importarECF"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <p
          align="justify"
          style="color: #383838; margin: 25px; font-size: 16px"
          id="excecao"
        >
          Como fazer download de um arquivo contendo ECF
        </p>
      </div>
       <p
          align="left"
          style="color: #383838; margin: 25px; font-size: 16px"
          id="excecao"
        >
          1. Instale o aplicativo ReceitanetBX no computador. O instalador do ReceitanetBX pode ser baixado do site do Sped, na área de download.
        </p>
         <p
          align="left"
          style="color: #383838; margin: 25px; font-size: 16px"
          id="excecao"
        >
          Nota: Escolha o perfil correto (Contribuinte, Procurador ou Representante Legal). Em caso de procuração, garante que a autorização de efetuar o download da ECF esteja marcada no e-CAC.
        </p>
         <p
          align="left"
          style="color: #383838; margin: 25px; font-size: 16px"
          id="excecao"
        >
          2. Após o download do arquivo da ECF, importe o arquivo ulitizando a funcionalidade "Arquivo/Importar" do programa da ECF.
        </p>
    </lefmodal>
    <lefmodal
      height="auto"
      width="1000px"
      :scrollable="true"
      :adaptive="true"
      name="excecao"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <p
          align="justify"
          style="color: #383838; margin: 25px; font-size: 20px"
          id="excecao"
        >
          {{ excecaoAtual }}
        </p>
      </div>
    </lefmodal>
    <lefmodal
      height="auto"
      width="1000px"
      :scrollable="true"
      :adaptive="true"
      name="adicionar"
    >
      <div
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
        "
      >
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            width: 90%;
            background: #eeeeee;
            margin-top: 25px;
            flex-direction: column;
          "
        >
          <p
            v-html="atualPergunta.pergunta"
            align="justify"
            style="color: #383838; margin: 25px"
          ></p>
        </div>

        <div
          v-for="(item, i) in atualPergunta.opcoes"
          :key="i"
          style="
            border-radius: 5px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            background: rgb(238, 238, 238);
            margin-top: 25px;
            width: 90%;
          "
        >
          <b-form-radio
            v-model="tt"
            name
            :value="i"
            class="large-bar-radio"
          ></b-form-radio>
          <p style="margin: 25px">{{ `${item.opcao}` }}</p>
        </div>
        <button
          @click="
            adicionarTT(
              atualPergunta.opcoes[tt].iprj,
              atualPergunta.opcoes[tt].csll
            )
          "
          class="adicionar-btn"
          style="
            font-size: 15px;
            width: 250px;
            height: 40px;
            margin-bottom: 40px;
            margin-top: 35px;
          "
        >
          Adicionar
        </button>
      </div>
    </lefmodal>
    <div style="margin: 10px 25px" class="conteiner">
      <!-- {{ this.$store.state.meses[0][3] }}
      {{ this.$store.state.api[3] }} -->
      <!-- #AF3437 #707070 -->
      <!-- menu de navegação -->
      <div class="nav-bar">
        <p v-if="$store.state.step == 1">
          Home /
          <strong style="color: #af3437">Simulação</strong>
        </p>
        <p
          v-if="
            $store.state.step == 2 ||
            $store.state.step == 3 ||
            $store.state.step == 4
          "
        >
          Home / Simulação /
          <strong style="color: #af3437">Regime</strong>
        </p>
      </div>

      <!-- step1 - simulação sera para? -->

      <div style="margin-left: 25px" v-if="$route.params.select == 'iniciar'">
        <p
          v-if="$store.state.step == 1"
          style="
            margin-top: 4px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          A simulação será para:
        </p>
        <div
          style="margin-bottom: 25px; margin-top: 40px"
          v-if="$store.state.step == 1"
          class="large-bar"
        >
         <!-- o value certo aqui é 2 -->
          <b-form-radio
            v-model="tiposimulacao"
            name="tiposimulacao"
            value="2" 
            class="large-bar-radio"
          ></b-form-radio>
          <p>
            Empresa existente em outro Regime Tributário<br />(Informar as
            receitas auferidas e os custos e despesas incorridos)
          </p>
        </div>

        <div v-if="$store.state.step == 1" class="large-bar">
          <b-form-radio
            v-model="tiposimulacao"
            name="tiposimulacao"
            value="1"
            class="large-bar-radio"
          ></b-form-radio>
          <p>
            Enquadramento para nova empresa<br />(Projetar as receitas esperadas
            e os custos e despesas estimados)
          </p>
        </div>

        <!-- step2 - regique que se enquadra -->

        <div style="margin-bottom: 65px" v-if="$store.state.step == 2 && $store.state.ecf == 1">
          <p
            style="
              margin-top: 40px;
              font-size: 16px;
              color: #383838;
              font-weight: 700;
            "
          >
            Selecione o código da atividade (podem ser incluídos até três
            códigos)
          </p>
          <p
            style="
              margin-top: 40px;
              font-size: 15px;
              color: #383838;
              font-weight: 500;
            "
          >
            CNAE / Descrição
          </p>
          <input
            placeholder="Pesquise por CNAE ou descrição"
            class="input-primary"
            type="text"
            style="display: inline"
            v-model="cnae"
            @keyup.enter="buscarCNAE()"
          />
          <button @click="buscarCNAE()">
            <i style="font-size: 25px; color: black" class="fas fa-search"></i>
          </button>
          <div v-if="resultadocnae">
            <div
              v-b-toggle.collapse-1
              class="notaexplicativa"
              v-if="resultadocnae[0].notaExplicativa"
            >
              <div style="cursor: pointer; width: 100%; display: flex">
                <p
                  style="
                    align-self: flex-end;
                    margin-top: 15px;
                    margin-left: 20px;
                    font-size: 15px;
                    font-weight: 600;
                  "
                >
                  Notas explicativas:
                </p>
              </div>
              <b-collapse id="collapse-1" class="mt-2">
                <p
                  style="padding: 0 20px 20px 20px; margin-top: 0"
                  v-html="resultadocnae[0].notaExplicativa"
                ></p>
              </b-collapse>
            </div>
          </div>
          <p
            style="
              margin-top: 40px;
              font-size: 14px;
              color: #383838;
              font-weight: 700;
            "
          >
            CNAE Buscados
          </p>
          <table
            v-if="resultadocnae.length != 0"
            style="width: 100%"
            class="table-cnae"
          >
            <thead>
              <tr
                style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <th style="text-align: center; max-width: 120px"></th>
                <th style="text-align: center; width: 80%">CNAE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="
                  display: flex;
                  width: 100%;
                  min-height: 30px;
                  margin-top: 20px;
                "
                v-for="(item, i) in resultadocnae"
                :key="i"
              >
                <td style="max-width: 120px">
                  <button
                    v-show="
                      $store.state.cnaeselecionados.filter((cnae) => cnae.cnae === item.cnae)
                        .length != 0
                    "
                    @click="remover(item.cnae, item.descricao, i)"
                    class="adicionar-btn"
                    style="margin: 0; max-width: 120px; height: 100%"
                  >
                    Remover
                  </button>
                  <button
                    v-show="
                      $store.state.cnaeselecionados.filter((cnae) => cnae.cnae === item.cnae)
                        .length == 0
                    "
                    @click="adicionar(item.cnae, item.descricao, i)"
                    class="adicionar-btn"
                    style="margin: 0; max-width: 120px; height: 100%"
                  >
                    Adicionar
                  </button>
                </td>
                <td
                  style="
                    width: 80%;
                    margin-left: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  {{ item.cnae }}
                  {{ item.descricao }}
                </td>
              </tr>
            </tbody>
          </table>

          <table
            v-if="resultadocnae.length == 0"
            style="width: 100%"
            class="table-cnae"
          >
            <tr
              style="
                margin-top: 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                background: #eeeeee;
                height: 40px;
              "
            >
              <p style="margin-bottom: 0">Pesquise um CNAE</p>
            </tr>
          </table>

          <p
            style="
              margin-top: 40px;
              font-size: 14px;
              color: #383838;
              font-weight: 700;
            "
          >
            CNAE Selecionados
          </p>

          <table
            v-if="$store.state.cnaeselecionados.length != 0"
            style="width: 100%"
            class="table-cnae"
          >
            <thead>
              <tr
                style="
                  width: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <th style="text-align: center; max-width: 120px"></th>
                <th style="text-align: center; width: 80%">CNAE</th>
              </tr>
            </thead>
            <tbody>
              <tr
                style="
                  display: flex;
                  width: 100%;
                  min-height: 30px;
                  margin-top: 20px;
                "
                v-for="(item, i) in $store.state.cnaeselecionados"
                :key="i"
              >
                <td style="max-width: 120px">
                  <button
                    v-show="
                      $store.state.cnaeselecionados.filter((cnae) => cnae.cnae === item.cnae)
                        .length != 0
                    "
                    @click="remover(item.cnae, item.descricao, i)"
                    class="adicionar-btn"
                    style="margin: 0; max-width: 120px; height: 100%"
                  >
                    Remover
                  </button>
                  <button
                    v-show="
                      $store.state.cnaeselecionados.filter((cnae) => cnae.cnae === item.cnae)
                        .length == 0
                    "
                    @click="adicionar(item.cnae, item.descricao, i)"
                    class="adicionar-btn"
                    style="margin: 0; max-width: 120px; height: 100%"
                  >
                    Adicionar
                  </button>
                </td>
                <td
                  style="
                    width: 80%;
                    margin-left: 20px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                >
                  {{ item.cnae }}
                  {{ item.descricao }}
                </td>
              </tr>
            </tbody>
          </table>

          <table
            v-if="$store.state.cnaeselecionados.length == 0"
            style="width: 100%"
            class="table-cnae"
          >
            <tr
              style="
                margin-top: 15px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 100%;
                background: #eeeeee;
                height: 40px;
              "
            >
              <p style="margin-bottom: 0">Adicione um CNAE</p>
            </tr>
          </table>
        </div>

        <div v-if="$store.state.step == 2 && $store.state.ecf == 2">
          <p
            style="
              display: inline;
              margin-top: 40px;
              font-size: 16px;
              color: #383838;
              font-weight: 700;
            "
          >
            Você deseja importar o documento contendo ECF da empresa que deseja
            analisar?
          </p>
          <i
            @click="$modal.show('importarECF')"
            style="cursor: pointer"
            class="fas fa-info-circle input-info"
          ></i>
          <div style="height:180px; border: 1px solid rgb(0,0,0,0.15); border-radius:7px; margin: 15px 0 0 0; width: 100%" class="flex-centered">
            <div v-if="$store.state.importouEcf == false && spinnerecf == false" class="flex-centered" style="width: 25%">
              <img  style="width: 65%" src="@/img/icontxt.png" alt="txt" />
            </div>
            <div
              v-if="spinnerecf == false"
              class="flex-centered"
              style="margin: 50px; width: 25%; flex-direction: column"
            >

              
              <label v-if="$store.state.importouEcf == false" class="label" for="myFile">Importar</label>
              <label style="margin:17px;" v-else class="label2" for="myFile">{{ ecfFile[0].name }}</label>

              <input
                style="margin: 0; color: white"
                class="continuar-btn"
                type="file"
                id="myFile"
                ref="myFile"
                multiple
                @change="importarEcf"
              />
            </div>
            <div
            v-if="spinnerecf == true"
            style="margin: 65px"
            class="flex-centered"
          >
            <b-spinner></b-spinner>
          </div>
          
          </div>
          <!-- <p>Até o momento só aceitamos ECF dos tipos: Lucro Real Trimestral e Lucro Real Anual</p> -->
          <!-- <div
            v-if="spinnerecf == false"
            style="margin: 65px"
            class="flex-centered"
          >
            <p style="margin: 0; padding: 0; font-size: 15px; font-weight: 700">
              {{ errosEcf }}
            </p>
          </div> -->
          <div class="buttons flex-centered">
            <button
              @click="$store.state.ecf = 1"
              :disabled="carregando"
              style="width: 200px; font-size: 16px"
              class="continuar-sem-btn"
              v-if="$store.state.importouEcf == false"
            >
              Continuar sem importar
            </button>
            <button
              @click="$store.state.ecf = 3"
              :disabled="carregando"
              class="continuar-btn"
            >
              Continuar
            </button>
          </div>
        </div>

        <div v-if="$store.state.step == 2 && $store.state.ecf == 3">
          <p
            style="
              display: inline;
              margin-top: 40px;
              font-size: 16px;
              color: #383838;
              font-weight: 700;
            "
          >
            Você quer confirmar dos dados importados?
          </p>
          <div style="margin-top: 40px; margin-bottom: 25px" class="large-bar">
            <b-form-radio
              v-model="tipocontinuar"
              name="tiposimulacao"
              value="1"
              class="large-bar-radio"
            ></b-form-radio>
            <p>
              Gostaria de conferir os dados antes de visualizar os resultados.
            </p>
          </div>
          <div style="margin-bottom: 25px" class="large-bar">
            <b-form-radio
              v-model="tipocontinuar"
              name="tiposimulacao"
              value="2"
              class="large-bar-radio"
            ></b-form-radio>
            <p>Não quero conferir os dados. Mostrar resultados diretamente.</p>
          </div>
          <div class="buttons flex-centered">
            <button @click="avancarECF()" class="continuar-btn">
              Continuar
            </button>
          </div>
        </div>

        <!-- <p
          v-if="$store.state.step == 2"
          style="margin-top: 40px; font-size:14px; color: #383838; font-weight: 700;"
        >Informe o Código CNAE e a sua receita para cada mês exportação indireta</p>

         <table
          v-if="resultadocnae.length != 0 && $store.state.step == 2"
          style="width:100%;"
          class="table-cnae"
        >
        <thead>
          <tr style="width:100%; display:flex; justify-content:center; align-items:center;">
            <th style="text-align:center;max-width:120px;"></th>
            <th style="text-align:center;width:80%">CNAE</th>
          </tr>
          </thead>
          <tbody>
          <tr style="display:flex;width:100%;min-height:30px;margin-top:20px;" v-for="(item,i) in resultadocnae" :key="i">
            <td style="max-width:120px;">
              <button
                v-show="$store.state.cnaeselecionados.filter(cnae => (cnae.cnae === item.cnae)).length != 0"
                @click="remover(item.cnae, item.descricao, i)"
                class="adicionar-btn"
                style="margin:0;max-width:120px; height:100%;"
              >Remover</button>
              <button
                v-show="$store.state.cnaeselecionados.filter(cnae => (cnae.cnae === item.cnae)).length == 0"
                @click="adicionar(item.cnae, item.descricao, i)"
                class="adicionar-btn"
                style="margin:0;max-width:120px; height:100%;"
              >Adicionar</button>
            </td>
            <td style="width:80%;margin-left:20px;display:flex;justify-content:center;align-items:center;">
              {{ item.cnae }}
              {{ item.descricao }}
            </td>
          </tr>
          </tbody>
        </table>

        <table
          v-if="resultadocnae.length == 0 && $store.state.step == 2"
          style="width:100%;"
          class="table-cnae"
        >
          <tr
            style="display:flex; justify-content:center; align-items: center; width:100%; background:#EEEEEE; height: 40px;"
          >
            <p style="margin-bottom: 0; ">Pesquise um CNAE</p>
          </tr>
        </table> -->

        <!-- <p
          v-if="$store.state.step == 2"
          style="margin-top: 40px; font-size:16px; color: #383838; font-weight: 700;"
        >Qual o regime tributário que ela está enquadrada?</p>
        <div v-if="$store.state.step == 2" class="large-bar">
          <b-form-radio
            v-model="regimeenquadrado"
            name="regimeenquadrado"
            value="simples"
            class="large-bar-radio"
          ></b-form-radio>
          <p>Simples nacional</p>
        </div> -->

        <!-- step3 - regique que se enquadra -->

        <p
          v-if="$store.state.step == 3"
          style="
            margin-top: 60px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Selecione um estado:
        </p>
        <select v-model="selecestado" v-if="$store.state.step == 3" name id>
          <option value="0">Escolha o estado</option>
          <option value="AC">Acre</option>
          <option value="AL">Alagoas</option>
          <option value="AP">Amapá</option>
          <option value="AM">Amazonas</option>
          <option value="BA">Bahia</option>
          <option value="CE">Ceará</option>
          <option value="DF">Distrito Federal</option>
          <option value="ES">Espírito Santo</option>
          <option value="GO">Goiás</option>
          <option value="MA">Maranhão</option>
          <option value="MT">Mato Grosso</option>
          <option value="MS">Mato Grosso do Sul</option>
          <option value="MG">Minas Gerais</option>
          <option value="PA">Pará</option>
          <option value="PB">Paraíba</option>
          <option value="PR">Paraná</option>
          <option value="PE">Pernambuco</option>
          <option value="PI">Piauí</option>
          <option value="RJ">Rio de Janeiro</option>
          <option value="RN">Rio Grande do Norte</option>
          <option value="RS">Rio Grande do Sul</option>
          <option value="RO">Rondônia</option>
          <option value="RR">Roraima</option>
          <option value="SC">Santa Catarina</option>
          <option value="SP">São Paulo</option>
          <option value="SE">Sergipe</option>
          <option value="TO">Tocantins</option>
          <option value="EX">Estrangeiro</option>
        </select>

        <p
          v-if="$store.state.step == 3"
          style="
            margin-top: 20px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          ISS:
        </p>
        <money
          class="input-iss"
          v-if="$store.state.step == 3"
          v-bind="percentage"
          v-model="iss"
          style="max-width: 200px"
          step="0.01"
          min="2"
          max="5"
        />

        <!-- step4 - regique que se enquadra MESES! -->
        <p
          v-if="$store.state.importouEcf == true && $store.state.step == 4"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Confirmar dados
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 1"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Receita Bruta - Mercado interno
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 2"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Receita Bruta - Mercado Externo Exportação Direta
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 3"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Receita Bruta - Mercado Externo Exportação Indireta
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 4"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Receita Bruta
        </p>
        <p
          v-if="
            ($store.state.step == 4 && $store.state.monthstep == 5) ||
            $store.state.monthstep == 6
          "
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Deduções da Receita Bruta
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 7"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Custos e despesas da atividade em geral
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 8"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Demais custos de produção ou prestação de serviço
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 9"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Folha de pagamento e encargos
        </p>
        <p
          v-if="
            ($store.state.step == 4 && $store.state.monthstep == 10) ||
            $store.state.monthstep == 11 ||
            $store.state.monthstep == 12
          "
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Despesas operacionais gerais
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 13"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Outras receitas operacionais
        </p>
        <p
          v-if="$store.state.step == 4 && $store.state.monthstep == 14"
          style="
            margin-top: 40px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
        >
          Outras despesas operacionais (demais despesas)
        </p>

        <div
          v-if="$store.state.step == 4 && $store.state.trimestral == true"
          style="width: 100%; justify-content: space-between"
          class="flex-centered"
        >
          <td
            @click="$store.state.month = 1"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 1 }"
          >
            1º Trimestre
          </td>

          <td
            @click="$store.state.month = 2"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 2 }"
          >
            2º Trimestre
          </td>

          <td
            @click="$store.state.month = 3"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 3 }"
          >
            3º Trimestre
          </td>

           <td
            @click="$store.state.month = 4"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 4 }"
          >
            4º Trimestre
          </td>
          
        </div>

        <div
          v-if="$store.state.step == 4 && $store.state.trimestral == false"
          style="width: 100%; justify-content: space-between"
          class="flex-centered"
        >
          <td
            @click="$store.state.month = 1"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 1 }"
          >
            Jan
          </td>
          <td
            @click="$store.state.month = 2"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 2 }"
          >
            Fev
          </td>
          <td
            @click="$store.state.month = 3"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 3 }"
          >
            Mar
          </td>
          <td
            @click="$store.state.month = 4"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 4 }"
          >
            Abr
          </td>
          <td
            @click="$store.state.month = 5"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 5 }"
          >
            Mai
          </td>
          <td
            @click="$store.state.month = 6"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 6 }"
          >
            Jun
          </td>
          <td
            @click="$store.state.month = 7"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 7 }"
          >
            Jul
          </td>
          <td
            @click="$store.state.month = 8"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 8 }"
          >
            Ago
          </td>
          <td
            @click="$store.state.month = 9"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 9 }"
          >
            Set
          </td>
          <td
            @click="$store.state.month = 10"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 10 }"
          >
            Out
          </td>
          <td
            @click="$store.state.month = 11"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 11 }"
          >
            Nov
          </td>
          <td
            @click="$store.state.month = 12"
            style="cursor: pointer; margin: 5px"
            :class="{ 'active-month': $store.state.month == 12 }"
          >
            Dez
          </td>
        </div>

        <div v-if="$store.state.step == 4" class="black-bar"></div>
        <div
          style="margin: 100px 0"
          class="flex-centered"
          v-if="$store.state.step == 4 && inputSpinner == true"
        >
          <b-spinner></b-spinner>
        </div>
        <!-- 1 -->

        <div v-if="$store.state.step == 4 && $store.state.monthstep == 1">
          <lefinput
            :api="$store.state.api[0]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 2 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 2">
          <lefinput
            :api="$store.state.api[1]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 3 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 3">
          <lefinput
            :api="$store.state.api[2]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 4 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 4">
          <lefinput
            :api="$store.state.api[3]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 5 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 5">
          <lefinput
            :api="$store.state.api[4]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 6 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 6">
          <lefinput
            @change.native="input()"
            :api="$store.state.api[5]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 7 -->
        <p
          style="
            margin-top: 20px;
            font-size: 16px;
            color: #383838;
            font-weight: 700;
          "
          v-if="$store.state.step == 4 && $store.state.monthstep == 7"
        >
          CUSTOS DA ATIVIDADE OPERACIONAL
        </p>
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 7">
          <lefinput
            @keyup.native="input()"
            :api="$store.state.api[6]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 8 DEMAIS CUSTOS DE PRODUÇÃO OU PRESTAÇÃO DE SERVIÇOS -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 8">
          <lefinput
            @keyup.native="input()"
            :api="$store.state.api[7]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 9 FOLHA DE PAGAMENTO E ENCARGOS -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 9">
          <lefinput
            @keyup.native="input()"
            :api="$store.state.api[8]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 10 DESPESAS OPERACIONAIS GERAIS -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 10">
          <lefinput
            :api="$store.state.api[9]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 11 DESPESAS OPERACIONAIS GERAIS -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 11">
          <lefinput
            :api="$store.state.api[10]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 12 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 12">
          <lefinput
            @keyup.native="input()"
            :api="$store.state.api[11]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 13 OUTRAS RECEITAS OPERACIONAIS -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 13">
          <lefinput
            @keyup.native="input()"
            :api="$store.state.api[12]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <!-- 14 -->
        <div v-if="$store.state.step == 4 && $store.state.monthstep == 14">
          <lefinput
            @keyup.native="input()"
            :api="$store.state.api[13]"
            :mes="$store.state.month"
            :tamanho="$store.state.api.lenght"
            :passomes="$store.state.monthstep"
          />
        </div>

        <div class="replicar">
          <p
            v-if="
              $store.state.step == 4 &&
              $store.state.monthstep != 4 &&
              $store.state.monthstep != 5
            "
            style="
              margin-top: 40px;
              font-size: 16px;
              color: #383838;
              font-weight: 700;
            "
          >
            Replicar informações
          </p>
          <select
            v-model="mesreplicar"
            v-if="
              $store.state.step == 4 &&
              $store.state.monthstep != 4 &&
              $store.state.monthstep != 5
            "
            style="margin: 25px 0 0 25px; height: 33px"
            name
            id
          >
            <option :value="0">Escolha o mês</option>
            <option :value="1">Janeiro</option>
            <option :value="2">Fevereiro</option>
            <option :value="3">Março</option>
            <option :value="4">Abril</option>
            <option :value="5">Maio</option>
            <option :value="6">Junho</option>
            <option :value="7">Julho</option>
            <option :value="8">Agosto</option>
            <option :value="9">Setembro</option>
            <option :value="10">Outubro</option>
            <option :value="11">Novembro</option>
            <option :value="12">Dezembro</option>
            <option :value="13">Todos os meses</option>
          </select>
          <button
            v-if="
              $store.state.step == 4 &&
              $store.state.monthstep != 4 &&
              $store.state.monthstep != 5
            "
            @click="emitGlobalClickEvent()"
            class="replicar-btn"
          >
            Replicar
          </button>
          <!-- <p
            v-if="$store.state.step == 4 && $store.state.monthstep != 4 && $store.state.monthstep != 5"
            style="font-size: 13px; margin: 23px 0 0 40px;"
          >Ver calendário comparativo do Simples Nacional</p> -->
        </div>
      </div>
      <div
        v-if="$store.state.step != 4 && this.$store.state.ecf == 1"
        class="buttons flex-centered"
      >
        <button
          v-if="$store.state.step != 1"
          @click="voltar()"
          :disabled="carregando"
          class="voltar-btn"
        >
          Voltar
        </button>
        <button @click="avancar()" :disabled="carregando" class="continuar-btn">
          Continuar 
        </button>
        <!-- <button @click="clcular()" class="continuar-btn">Calcular</button> -->
      </div>
      <div
        v-if="$store.state.step == 4 && $store.state.monthstep != 4"
        class="buttons flex-centered"
      >
        <button
          v-if="$store.state.step"
          @click="voltar()"
          :disabled="carregando"
          class="voltar-btn"
        >
          Voltar
        </button>
        <button
          v-if="$store.state.importouEcf == false"
          @click="avancar()"
          :disabled="carregando"
          class="continuar-btn"
        >
          Continuar
        </button>
        <button
          v-if="$store.state.importouEcf == true"
          @click="avancar()"
          :disabled="carregando"
          class="continuar-btn"
        >
          Confirmar 
        </button>
        <!-- <button @click="calcular()" class="continuar-btn">Calcular</button> -->
      </div>
      <div
        v-if="$store.state.step == 4 && $store.state.monthstep == 4"
        class="buttons flex-centered"
      >
        <button
          @click="voltar()"
          :disabled="carregando"
          class="voltar-btn"
        >
          Voltar
        </button>
        <button
          v-if="$store.state.importouEcf == false"
          @click="avancar()"
          :disabled="carregando"
          class="continuar-btn"
        >
          Continuar
        </button>
        <button
          v-if="$store.state.importouEcf == true"
          @click="avancar()"
          :disabled="carregando"
          class="continuar-btn"
        >
          Confirmar
        </button>
        <!-- <button @click="calcular()" class="continuar-btn">Calcular</button> -->
      </div>
    </div>
  </div>
</template>

<script>
import lefinput from "../Lefinput";
import { Money } from "v-money";
import api from "../../services/api";
import EventBus from "../../event-bus";
export default {
  components: { Money, lefinput },
  data() {
    return {
      atualPergunta: {},
      excecaoAtual: "",
      resultadoInfoDeduc: [],
      iss: 2.0,
      percentage: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "%",
        precision: 2,
        masked: false,
        min: 2,
        max: 5,
        valueTotal: 0,
      },
      ecfFile: [],
      inputSpinner: false,
      objetoCnae: [],
      carregando: false,
      selecestado: "0",
      seleciss: 2,
      cnaeextenso: "",
      cnaes: [{}],
      cnae: "",
      tt: 0,
      spinnerecf:false,
      errosEcf: "",
      regimeenquadrado: "",
      tiposimulacao: 2,
      tipocontinuar: 1,
      mesreplicar: 0,
      resultadocnae: "",
      resultadocalculos: "",
      resultadomercados: "",
      resultadoCustos: [],
      resultadoFolha: [],
      resultadoReceita: [],
      adicionarcnae: {},
      textoExf: "",
      totais: [
        //variavel que guarda a soma de cada mercado para cada mes
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
      ],
    };
  },
  watch: {
    iss(n, o) {
      if (this.iss > 5.0) {
        this.iss = 5;
      }
      if (this.iss < 2.0) {
        this.iss = 2;
      }
    },
  },
  computed: {},
  props: ["view"],
  async created() {
    this.resultadoInfoDeduc = await api.infoBuscar("deducoes");
    this.resultadoCustos = await api.infoBuscar("custosDespesas");
    this.resultadoFolha = await api.infoBuscar("folhaPagamento");
    this.resultadoReceita = await api.infoBuscar("receitaBruta");
    console.log(this.resultadoInfoDeduc)
    this.setaInfos();
  },
  methods: {
    enviarEcf() {
    },
    async importarEcf(event) {
      this.spinnerecf = true;
      this.ecfFile = this.$refs.myFile.files;
      console.log(this.ecfFile)
      var reader = new FileReader();
      reader.onload = async () => {

       try {
         let linha = reader.result.split("\n");
         console.log(linha)
         let linhaCnae = [];
         let temCnae = false;
         linha.forEach((linha,index)=>{
           let colunas = linha.split('|');
           if(colunas[1] == "0030"){
             if(colunas[3].length == 7){
              
               this.selecestado = colunas[8];
               console.log( this.selecestado)
               temCnae = true;
               linhaCnae = colunas;
             }
           }else{
           }
         })
        if(temCnae == true){
        let resultadocnae = await this.buscarCNAEECF(linhaCnae[3]);
        if(resultadocnae == undefined){
          this.errosEcf = "CNAE Inválido!"
          this.spinnerecf = false;
        }else{
        this.adicionarTTECF(
              resultadocnae[0].irpj,
              resultadocnae[0].csll,
              resultadocnae[0]
            );


        this.cadastraIcms(["L300","P150"],["(-) ICMS"],4,0,reader.result)

        if(this.$store.state.presumido == true){
            this.cadastraIrpj(["P300"],["IMPOSTO DE RENDA A PAGAR"],reader.result);
            this.cadastraCsll(["P500"],["CSLL A PAGAR"],reader.result);
        }else{
          if(this.$store.state.trimestral == true){
            this.cadastraIrpj(["N630","P300"],["IMPOSTO DE RENDA A PAGAR"],reader.result); //BASE DE CÁLCULO DO IRPJ
            this.cadastraCsll(["N670","P500"],["CSLL A PAGAR"],reader.result);
          }else{
            this.cadastraIrpj(["N620","P300"],["IMPOSTO DEVIDO NO MÊS"],reader.result); //BASE DE CÁLCULO DO IRPJ
            this.cadastraCsll(["N660","P500"],["CSLL DEVIDA NO MÊS"],reader.result);
          }
        }
          
        
        // this.cadastraIrpj2(["N630","P100"],["IMPOSTO SOBRE O LUCRO REAL"],reader.result);
        // this.cadastraIrpj3(["N630","P100"],["À Alíquota de 15%"],reader.result);
        // this.cadastraIrpj4(["N630","P100"],["Adicional"],reader.result);
        // this.cadastraIrpj5(["N630","P100"],[""],reader.result);

        
        this.cadastraIpi(["L100","P100"],["IPI a Recolher - Circulante"],reader.result);
        this.cadastraPrev("(-) Encargos Sociais - Previdência Social", "(-) Encargos Sociais - FGTS",reader.result)
        

        //1
        this.cadastraMerInterno(["L300","P150"],0,0,reader.result)

        this.cadastraEcf(["L300","P150"],["Receita de Exportação Direta de Mercadorias e Produtos"],1,0,reader.result)
        this.cadastraEcf(["L300","P150"],["Receita de Vendas de Mercadorias e Produtos a Comercial Exportadora com Fim Específico de Exportação"],2,0,reader.result)
        

        
        //4
        
        this.cadastraIcms(["L300"],["(-) COFINS Sobre Receita Bruta"],4,2,reader.result)
        this.cadastraIcms(["L300"],["(-) PIS/PASEP Sobre Receita Bruta"],4,1,reader.result)
        this.cadastraIcms(["P150"],["(-) COFINS Sobre Receita Bruta"],4,4,reader.result)
        this.cadastraIcms(["P150"],["(-) PIS/PASEP Sobre Receita Bruta"],4,3,reader.result)
        if(this.$store.state.presumido == false){
          this.cadastraIcms(["L300"],["(-) ISS"],4,5,reader.result)
        }else{
          this.cadastraIcms(["P150"],["(-) ISS"],4,5,reader.result)
        }

        //5
        this.cadastraIcms(["L300","P150"],["(-) Vendas Canceladas e Devoluções de Vendas"],5,0,reader.result)
        this.cadastraIcms(["L300","P150"],["(-) Descontos Incondicionais e Abatimentos"],5,1,reader.result)

        // //6
        this.cadastraEstoques("L210","Estoques no Início do Período de Apuração",6,0,reader.result,'2')
        this.cadastraEstoques("L210","Estoques no Início do Período de Apuração",6,3,reader.result,'33')
        this.cadastraEstoques("L210","(-) Estoques no Final do Período de Apuração",6,2,reader.result,'30')
        this.cadastraEstoques("L210","(-)Estoques no Final do Período de Apuração",6,5,reader.result,'36')
        this.cadastraSomaDois("Compras de Insumos no Mercado Interno", "Compras de Insumos no Mercado Externo",6,1,reader.result) // insumos
        this.cadastraSomaDois("Compras de Mercadorias no Mercado Interno", "Compras de Mercadorias no Mercado Externo",6,4,reader.result) //revenda

        // //7
        this.cadastraIcms(["L300","P150"], ["(-) Despesas com Energia Elétrica"],7,0,reader.result)
        this.cadastraIcms2(["L210"], ["Manutenção e Reparo de Bens Aplicados na Produção de Serviços"],7,1,reader.result)
        //Combustíveis (Produção e Prestação de Serviços) - (-) Custo dos Produtos de Fabricação Própria Vendidos
        //Equipamento de Proteção Individual (Produção e Prestação de serviços) '
        //Encargos de Depreciação Máquinas e Equipamentos (Produção e Prestação de Serviços) '
        //Custos no Desenvolvimento de Produtos 
        //Encargos de Amortização
        //Encargos de Depreciação de Veículos (Prestação de Serviços)
        //Serviços de Terceiros (Pessoa Jurídica)
        //Seguros (Produção e Prestação de Serviços)

        // //8
        this.cadastraIcms(["L300","P150"], ["(-) Remuneração a Dirigentes e a Conselho de Administração"],8,0,reader.result)
        this.cadastraIcms(["L300","P150"], ["(-) Ordenados, Salários, Gratificações e Outras Remunerações a Empregados"],8,1,reader.result)
        this.cadastraIcms2(["L210"], ["Serviços Prestados por Terceiros"],8,2,reader.result)

        //9
        this.cadastraIcms(["L300","P150"], ["(-) Aluguéis"],9,0,reader.result)
        this.cadastraIcms(["L300","P150"], ["(-) Arrendamento Mercantil"],9,1,reader.result)

        // //Armazenagem de mercadoria e frete na operação de venda

        this.cadastraIcms(["L300","P150"], ["(-) Encargos de Depreciação"],9,3,reader.result)

        this.cadastraIcms(["L300","P150"],["(-) Outros Gastos com Pessoal"],9,4,reader.result)
        
        this.cadastraIcms(["L300","P150"], ["(-) Alimentação do Trabalhador"],9,5,reader.result)

        // Uniformes - Outras Receitas Operacionais
        // //EPI (Atividade Administrativa ou Comercial)
        // //Despesas com Vendas - Outras Receitas Operacionais

        this.cadastraIcms(["L300","P150"],["(-) Despesas com Veículos e de Conservação de Bens e Instalações"],9,9,reader.result)


        // //10
        // //Combustível
        this.cadastraIcms(["L300","P150"], ["(-) Despesas com Água e Esgoto"],10,1,reader.result)
        this.cadastraIcms(["L300","P150"], ["(-) Despesas com Telefone e Internet"],10,2,reader.result)
        this.cadastraIcms(["L300","P150"], ["(-) Despesas com Seguros"],10,3,reader.result)
        // //Materiais de Consumo e Limpeza
        // //Previdência Privada
        this.cadastraIcms(["L300","L150","P150"], ["(-) Assistência Médica, Odontológica e Farmacêutica a Empregados"],10,6,reader.result)
        this.cadastraIcms(["L300","L150","P150"], ["(-) Gratificações a Administradores"],10,7,reader.result)
        // //Participação nos Lucros e Resultados
        // //Comissões e Representações

        // //11
        
        this.cadastraIcms(["L300","P150"], ["(-) Propaganda, Publicidade e Patrocínio"],11,0,reader.result)

        this.cadastraIcms(["L300", "P150"], ["(-) Outras Contribuições, Doações e Patrocínios"],11,1,reader.result)
        // //Amostra Grátis
        this.cadastraIcms(["L300","P150"],["(-) Outros Serviços Prestados  por Pessoa Física ou Jurídica"],11,3,reader.result)
        // //Viagens - Outras Receitas Operacionais
        // //Demais despesas administrativas
        // //Demais despesas com vendas - Outras Receitas Operacionais
        //  this.cadastraEcf(["L300","P150"], ["(-) Outras Despesas Operacionais"],11,7,reader.result)
         this.cadastraIcms(["L300","P150"], ["(-) Multas"],11,8,reader.result)



        //12
        this.cadastraIcms(["L300","P150"], ["Variações Cambiais Ativas"],12,0,reader.result)
        this.cadastraIcms(["L300","P150"], ["Ganhos Auferidos no Mercado de Renda Variável, exceto Day-Trade"],12,1,reader.result)
        this.cadastraIcms(["L300","P150"], ["Ganhos em Operações Day-Trade"],12,2,reader.result)
        this.cadastraIcms(["L300","P150"], ["Receitas de Juros sobre o Capital Próprio"],12,3,reader.result)
        this.cadastraIcms(["L300","P150"], ["Outras Receitas Financeiras"],12,4,reader.result)
        //Resultados Positivos
        this.cadastraIcms(["L300","P150"], ["Rendimentos e Ganhos de Capital Auferidos no Exterior"],12,6,reader.result)
        this.cadastraIcms(["L300","P150"], ["Reversão das Perdas Estimadas Decorrentes de Teste de Recuperabilidade (Impairment)"],12,7,reader.result)
        this.cadastraIcms(["L300","P150"], ["Prêmios Recebidos; Doações e Subvenções"],12,8,reader.result)
        this.cadastraIcms(["L100","P100"], ["Subvenção Governamental a Apropriar"],12,9,reader.result)
        //Receita de Aluguel de Bens (não objeto da empresa)
        this.cadastraIcms(["L300","P150"], ["Outros Créditos Fiscais Presumidos"],12,11,reader.result)
        this.cadastraIcms(["L300","P150"], ["Multas e Outras Vantagens Recebidas"],12,12,reader.result)
        this.cadastraIcms(["L300","P150"], ["Lucros e Dividendos Derivados de Participações Societárias Avaliadas pelo Custos de Aquisição"],12,13,reader.result)
        this.cadastraIcms(["L300","P150"], ["Receitas com Empréstimos de Valores Mobiliários"],12,14,reader.result)
        this.mutuoSomaDois("Rendimentos Auferidos em Operações de Mútuo – Partes Relacionadas", "Rendimentos Auferidos em Operações de Mútuo – Partes Não Relacionadas",12,15,reader.result)
        //Ganho de Ajustes a Valor Justo
        this.cadastraIcms(["L300","P150"], ["Outras Receitas Operacionais"],12,17,reader.result)
        this.cadastraIcms(["L300","P150"], ["Lucros e Dividendos Derivados de Participações Societárias Avaliadas pelo Custos de Aquisição"],12,18,reader.result)

        // //13 
        this.cadastraIcms(["P150","L300"], ["(-) Descontos Incondicionais e Abatimentos"],13,0,reader.result)
        this.cadastraIcms(["P150","L300"], ["(-) Despesas Financeiras Decorrentes dos Ajustes ao Valor Presente"],13,1,reader.result)
        this.cadastraIcms(["P150","L300"], ["(-) Demais Impostos, Taxas e Contribuições, exceto IR e CSLL"],13,2,reader.result)
        //Despesas Bancárias
        //Variações Monetárias Passivas
        this.cadastraIcms(["P150","L300"], ["(-) Variações Cambiais Passivas"],13,5,reader.result)
        this.cadastraIcms(["P150","L300"], ["(-) Despesas de Juros sobre o Capital Próprio"],13,6,reader.result)
        this.cadastraIcms(["P150","L300"], ["(-) Resultados Negativos em Participações Societárias Avaliadas pelo Método de Equivalência Patrimonial"],13,7,reader.result)
        this.cadastraIcms(["P150","L300"], ["(-) Perdas Estimadas Decorrentes de Teste de Recuperabilidade (Impairment)"],13,8,reader.result)
        this.cadastraIcms(["P150","L300"],["(-) Valor Contábil dos Bens e Direitos do Ativo Não Circulante Investimentos, Intangível e Imobilizado Alienados"],13,9,reader.result)
        //Perda na Avaliação a Valor Justo
        this.cadastraIcms(["P150","L300"], ["(-) Outras Despesas Operacionais"],13,11,reader.result)
        
        if(this.$store.state.presumido == true){
          // this.$notify({group: 'foo',type:"error",speed:1000,title: 'Ops',text: 'Não aceitamos Lucro Presumido até o momento.',});
          // this.$store.state.trimestral = false;
          // this.$store.state.importouEcf = false;
          // this.$store.state.presumido = false;
          this.$notify({group: 'foo',type:"success",speed:1000,title: 'Sucesso!',text: 'Seu arquivo foi importado.',});
          this.$store.state.importouEcf = true;
          
        }else{
          this.$notify({group: 'foo',type:"success",speed:1000,title: 'Sucesso!',text: 'Seu arquivo foi importado.',});
          this.$store.state.importouEcf = true;
          
        }
        this.spinnerecf = false;
        }     
         }else{
           this.errosEcf = "Campo CNAE_FISCAL não foi encontrado."
           this.$notify({group: 'foo',type:"error",speed:1000,title: 'Ops',text: `Erro! ${this.errosEcf}`,});
           this.spinnerecf = false;
           this.$store.state.importouEcf = false;
           this.$store.state.trimestral = false;
           this.$store.state.presumido = false;
         }
       }catch (error){
         alert(error)
       }
      };
      reader.readAsText(this.ecfFile[0], "ISO-8859-1");
    },
    cadastraIcms(codigo,titulo,x,y,reader){
      
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){             
            titulo.forEach((tit,index)=>{                   
              if(coluna[3].toUpperCase() == tit.toUpperCase()){   
                
                  titulos.push(coluna);
                  console.log(titulos);
                }
            })
            }
          })
        });
        
        
        
        if(titulo[0] == "(-) ICMS"){
          console.log(codigo)
          if(titulos.length == 4){
            this.$store.state.trimestral = true;
          }
        }
        titulos.forEach((titulo,index) => {
          if(titulo[1] == "P150"){
            this.$store.state.presumido = true;
            
          }
          let valor = titulo[8];
          
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          console.log("----Index------")
          console.log(index)
          console.log("-----Index-----")
          if(this.$store.state.trimestral == true){      
            console.log("-------Meses  trimestral-------") 
            console.log(this.$store.state.meses[index-1])
            console.log("--------Meses  trimestral------") 
            if(index == 0){
                this.$store.state.meses[0][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.meses[3][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.meses[6][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.meses[9][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){   
                console.log("-------Meses -------") 
                console.log(this.$store.state.meses[index-1][x][y],parseFloat(valor) - parseFloat(valorAnterior))
                console.log("--------Meses ------")              
                this.$store.state.meses[index-1][x][y].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraIcms2(codigo,titulo,x,y,reader){
        
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          let valor = titulo[4];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[4];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.meses[0][x][y].valor = parseFloat(valor) <= 0 || valor == "" ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.meses[3][x][y].valor = parseFloat(valor) <= 0 || valor == "" ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.meses[6][x][y].valor = parseFloat(valor) <= 0 || valor == "" ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.meses[9][x][y].valor = parseFloat(valor) <= 0 || valor == "" ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                if(valor == ""){
                  this.$store.state.meses[index-1][x][y].valor = 0
                }else{
                  this.$store.state.meses[index-1][x][y].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 || valor == "" ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
                }
                
              }     
          }
        })
    },
    cadastraEcf(codigo,titulo,x,y,reader){
        console.log('------------ cadastrar ecf ---------------')
        console.log(this.$store.state.api)
        console.log(this.$store.state.trimestral)
        console.log('------------- cadastrar ecf --------------')
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            
            if(coluna[1] == cod){
              
            titulo.forEach((tit,index)=>{
              console.log("--------------")
              console.log(coluna[3].toUpperCase())
              console.log(tit.toUpperCase())
              console.log("--------------")
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
              titulos.push(coluna);
              }
            })
            }
          })
        });
        if(titulo[0] == "(-) ICMS"){        
          if(titulos.length == 4){
            this.$store.state.trimestral = true;
          }
        }
        console.log("-----------titulos--------")
        console.log(titulos)
        console.log("-----------titulos--------")
        titulos.forEach((titulo,index) => {
          let valor = titulo[8];
          console.log("------valor------")
          console.log(valor)
          console.log("------valor------")
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            this.$store.state.api[x][y].value.push(parseFloat(valor) <= 0 ? 0 : parseFloat(valor));
          }else{
            this.$store.state.api[x][y].value.push(parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior));
          }
          
        })
    },
    cadastraEstoques(codigo,titulo,x,y,reader,tipo){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        console.log("tipo: " + tipo)
        linhas.forEach((linha,index) => {
           coluna = linha.split("|");
          if(coluna[1] == codigo){
            if(coluna[3].toUpperCase() == titulo.toUpperCase()){ 
              if(coluna[2] == tipo){
                titulos.push(coluna);
              }
          }
         }
        });
        titulos.forEach((titulo,index) => {
          let valor = titulo[4];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[4];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
              this.$store.state.meses[0][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
            }
            if(index == 1){
              this.$store.state.meses[3][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
            }
            if(index == 2){
              this.$store.state.meses[6][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
            }
            if(index == 3){
              this.$store.state.meses[9][x][y].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
            }
          }else{
            if(index > 0 && index < 13){
                this.$store.state.meses[index-1][x][y].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }    
          }
          console.log(this.api)
        })
    },
    cadastraSomaDois(tituloUm,tituloDois,n1,n2,result){
      let linhas = result.split("\n");
      let interno = [];
      let externo = [];
      linhas.forEach((linha,index)=>{
        let coluna = linha.split("|");
        if(coluna[3] === tituloUm){
          interno.push(coluna[4])//erro ao colocar .toUpperCase()
        }
        if(coluna[3] === tituloDois){
          externo.push(coluna[4]) // erro ao colocar .toUpperCase()
        }
      })
      for(let i = 0; i < 13; i++){
          if(this.$store.state.trimestral == false){
            if(i > 0 && i < 13){
              if(i == 1){
                this.$store.state.meses[i-1][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
              }else{
                this.$store.state.meses[i-1][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i]) - parseFloat(interno[i - 1]) + parseFloat(externo[i - 1])
              }
            }
          }else{
            if(i == 0){
              this.$store.state.meses[0][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 1){
              this.$store.state.meses[3][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 2){
              this.$store.state.meses[6][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 3){
              this.$store.state.meses[9][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
          }   
      }
    },
    mutuoSomaDois(tituloUm,tituloDois,n1,n2,result){
      let linhas = result.split("\n");
      let interno = [];
      let externo = [];
      linhas.forEach((linha,index)=>{
        let coluna = linha.split("|");
        if(coluna[3] === tituloUm){
          interno.push(coluna[8])
        }
        if(coluna[3] === tituloDois){
          externo.push(coluna[8])
        }
      })
      for(let i = 0; i < 13; i++){
          if(this.$store.state.trimestral == false){
            if(i > 0 && i < 13){
              if(i == 1){
                this.$store.state.meses[i-1][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
              }else{
                this.$store.state.meses[i-1][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i]) - parseFloat(interno[i - 1]) + parseFloat(externo[i - 1])
              }
            }
          }else{
            if(i == 0){
              this.$store.state.meses[0][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 12){
              this.$store.state.meses[3][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 2){
              this.$store.state.meses[6][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 3){
              this.$store.state.meses[9][n1][n2].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
          }   
      }
    },
    cadastraMerInterno(titulos,n1,n2,result){
      let linhas = result.split("\n");
      let interno = 0;
      let externo = 0;
      let values = [];
      let valuesUm = [];
      let valuesDois = [];
      let valuesTres = [];
      linhas.forEach((linha,index)=>{
      let coluna = linha.split("|");
        titulos.forEach((tit)=>{
          if(tit == coluna[1]){
            
            if(coluna[3].toUpperCase() == "Receita da Venda de Produtos de Fabricação Própria no Mercado Interno".toUpperCase()){
              valuesUm.push(coluna[8]);
            }
            if(coluna[3].toUpperCase() == "Receita da Revenda de Mercadorias no Mercado Interno".toUpperCase()){
              valuesDois.push(coluna[8]);
            }
            if(coluna[3].toUpperCase() == "Receita da Prestação de Serviços no Mercado Interno".toUpperCase()){
            
              valuesTres.push(coluna[8]);
            }
          }
        })
      })
      for(var i = 0; i < 13; i++){
        if(i < 2){
          values.push(parseFloat(valuesUm[i]) + parseFloat(valuesDois[i]) + parseFloat(valuesTres[i]));
        }else{
          if(this.$store.state.trimestral == false){
            values.push((parseFloat(valuesUm[i]) + parseFloat(valuesDois[i]) + parseFloat(valuesTres[i])) - (parseFloat(valuesUm[i - 1]) + parseFloat(valuesDois[i - 1]) + parseFloat(valuesTres[i - 1])));
          }else{
             values.push((parseFloat(valuesUm[i]) + parseFloat(valuesDois[i]) + parseFloat(valuesTres[i])));
          }
          
         
        }
      }
      this.$store.state.api[0][0].value = values
    },
    cadastraCsll(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        if(titulo[0] == "(-) ICMS"){
          if(titulos.length == 4){
            this.$store.state.trimestral = true;
          }
        }
        titulos.forEach((titulo,index) => {
          console.log(titulo)
          let valor = titulo[4];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[4];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfCsll[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfCsll[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfCsll[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfCsll[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
                this.$store.state.ecfCsll[index].valor = parseFloat(valor) // - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)   
          }
        })
    },
    cadastraCsll2(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        if(titulo[0] == "(-) ICMS"){
          if(titulos.length == 4){
            this.$store.state.trimestral = true;
          }
        }
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfCsll2[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfCsll2[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfCsll2[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfCsll2[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfCsll2[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraCsll3(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        if(titulo[0] == "(-) ICMS"){
          if(titulos.length == 4){
            this.$store.state.trimestral = true;
          }
        }
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfCsll3[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfCsll3[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfCsll3[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfCsll3[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfCsll3[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraCsll4(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        if(titulo.toUpperCase() == "(-) ICMS"){
          if(titulos.length == 4){
            this.$store.state.trimestral = true;
          }
        }
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfCsll4[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfCsll4[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfCsll4[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfCsll4[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfCsll4[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraIrpj(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          console.log(titulo)
          let valor = titulo[4];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[4];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfIrpj[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfIrpj[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfIrpj[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfIrpj[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              this.$store.state.ecfIrpj[index].valor = parseFloat(valor) // - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)    
          }
        })
    },
    cadastraIrpj2(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfIrpj2[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfIrpj2[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfIrpj2[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfIrpj2[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfIrpj2[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraIrpj3(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfIrpj3[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfIrpj3[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfIrpj3[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfIrpj3[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfIrpj3[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraIrpj4(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfIrpj4[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfIrpj4[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfIrpj4[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfIrpj4[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfIrpj4[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraIrpj5(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfIrpj5[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfIrpj5[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfIrpj5[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfIrpj5[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfIrpj5[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraIpi(codigo,titulo,reader){
        let linhas = reader.split("\n");
        let coluna = [];
        let titulos = [];
        linhas.forEach((linha,index) => {
          coluna = linha.split("|");
          codigo.forEach((cod,index)=>{
            if(coluna[1] == cod){
            titulo.forEach((tit,index)=>{
              if(coluna[3].toUpperCase() == tit.toUpperCase()){
            titulos.push(coluna);
          }
            })
            }
          })
        });
        titulos.forEach((titulo,index) => {
          console.log(titulo)
          let valor = titulo[8];
          let valorAnterior = 0;
          let colunaAnterior = [];
          if(index == 0 || index == 1){
            valorAnterior = 0
          }else{
            colunaAnterior = titulos[index - 1]
            valorAnterior = colunaAnterior[8];
          }
          if(this.$store.state.trimestral == true){
            if(index == 0){
                this.$store.state.ecfIpi[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 1){
                this.$store.state.ecfIpi[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
            if(index == 2){
                this.$store.state.ecfIpi[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }
            if(index == 3){
                this.$store.state.ecfIpi[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
              }  
          }else{
              if(index > 0 && index < 13){
                this.$store.state.ecfIpi[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
              }     
          }
        })
    },
    cadastraPrev(tituloUm,tituloDois,result){
      let linhas = result.split("\n");
      let interno = [];
      let externo = [];
      linhas.forEach((linha,index)=>{
        let coluna = linha.split("|");
        if(coluna[3] === tituloUm){
          console.log(coluna[3])
          interno.push(coluna[8])
        }
        if(coluna[3] === tituloDois){
          console.log(coluna[3])
          externo.push(coluna[8])
        }
      })
      for(let i = 0; i < 13; i++){
          if(this.$store.state.trimestral == false){
            if(i > 0 && i < 13){
              if(i == 1){
                this.$store.state.ecfPrevidencia[i-1].valor = parseFloat(interno[i]) + parseFloat(externo[i])
              }else{
                this.$store.state.ecfPrevidencia[i-1].valor = parseFloat(interno[i]) + parseFloat(externo[i]) - parseFloat(interno[i - 1]) + parseFloat(externo[i - 1])
              }
            }
          }else{
            if(i == 0){
              this.$store.state.ecfPrevidencia[0].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 1){
              this.$store.state.ecfPrevidencia[3].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 2){
              this.$store.state.ecfPrevidencia[6].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
            if(i == 3){
              this.$store.state.ecfPrevidencia[9].valor = parseFloat(interno[i]) + parseFloat(externo[i])
            }
          }   
      }
    },
    // cadastraPrev(codigo,number,titulo,reader){
    //     let linhas = reader.split("\n");
    //     let coluna = [];
    //     let titulos = [];
    //     linhas.forEach((linha,index) => {
    //       coluna = linha.split("|");
    //       codigo.forEach((cod,index)=>{
    //         if(coluna[1] == cod){
    //         titulo.forEach((tit,index)=>{
    //           if(coluna[3] == tit){
    //             number.forEach((num,index)=>{
    //               if(coluna[2] == number){
    //                 titulos.push(coluna);
    //               }
    //             })
    //       }
    //         })
    //         }
    //       })
    //     });
    //     titulos.forEach((titulo,index) => {
    //       console.log(titulo)
    //       let valor = titulo[4];
    //       let valorAnterior = 0;
    //       let colunaAnterior = [];
    //       if(index == 0 || index == 1){
    //         valorAnterior = 0
    //       }else{
    //         colunaAnterior = titulos[index - 1]
    //         valorAnterior = colunaAnterior[4];
    //       }
    //       if(this.$store.state.trimestral == true){
    //         if(index == 0){
    //             this.$store.state.ecfPrevidencia[0].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
    //           }
    //         if(index == 1){
    //             this.$store.state.ecfPrevidencia[3].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
    //           }  
    //         if(index == 2){
    //             this.$store.state.ecfPrevidencia[6].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
    //           }
    //         if(index == 3){
    //             this.$store.state.ecfPrevidencia[9].valor = parseFloat(valor) <= 0 ? 0 : parseFloat(valor)
    //           }  
    //       }else{
    //           if(index > 0 && index < 13){
    //             this.$store.state.ecfPrevidencia[index-1].valor = parseFloat(valor) - parseFloat(valorAnterior) <= 0 ? 0 : parseFloat(valor) - parseFloat(valorAnterior)
    //           }     
    //       }
    //     })
    // },
    //chamado ao digitar no input
    
    setaInfos() {
      console.log("------ seta infos -----");
      console.log(this.resultadoInfoDeduc)
      this.$store.state.api[4][0].info = this.resultadoInfoDeduc[0].informacao;
      this.$store.state.api[4][1].info = this.resultadoInfoDeduc[1].informacao;
      this.$store.state.api[4][2].info = this.resultadoInfoDeduc[3].informacao;
      this.$store.state.api[4][3].info = this.resultadoInfoDeduc[2].informacao;
      this.$store.state.api[4][4].info = this.resultadoInfoDeduc[4].informacao;
      this.$store.state.api[4][5].info = this.resultadoInfoDeduc[5].informacao;
      this.$store.state.api[5][0].info = this.resultadoInfoDeduc[6].informacao;
      this.$store.state.api[5][1].info = this.resultadoInfoDeduc[7].informacao;
      this.$store.state.api[6][0].info = this.resultadoCustos[0].informacao;
      this.$store.state.api[6][1].info = this.resultadoCustos[1].informacao;
      this.$store.state.api[6][2].info = this.resultadoCustos[2].informacao;
      this.$store.state.api[6][6].info = this.resultadoCustos[3].informacao;
      this.$store.state.api[6][3].info = this.resultadoCustos[0].informacao;
      this.$store.state.api[6][4].info = this.resultadoCustos[4].informacao;
      this.$store.state.api[6][5].info = this.resultadoCustos[2].informacao;
      this.$store.state.api[8][3].info = this.resultadoFolha[0].informacao;
      this.$store.state.api[8][4].info = this.resultadoFolha[1].informacao;
    },
    setaInfoReceita() {
      for (let i = 0; i < this.$store.state.cnaeselecionados.length; i++) {
        
        this.$store.state.api[0][i].info = this.resultadoReceita[0].informacao;
        this.$store.state.api[1][i].info = this.resultadoReceita[1].informacao;
        this.$store.state.api[2][i].info = this.resultadoReceita[2].informacao;
      }
    },
    input() {
     for(let i = 0; i < 12; i++){
      console.log("começou a montat o step")
      console.log(this.$store.state.monthstep)
    if(this.$store.state.monthstep >= 4){
       
            this.$store.state.meses[i][5][3].valor = this.$store.state.resultadodeducao.deducoes.icms[0].valor +
            this.$store.state.resultadodeducao.deducoes.piS_LP[0].valor +
            this.$store.state.resultadodeducao.deducoes.cofinS_LP[0].valor +
            this.$store.state.resultadodeducao.deducoes.iss[0].valor +
            this.$store.state.meses[i][5][0].valor +
            this.$store.state.meses[i][5][1].valor;

            this.$store.state.meses[i][5][2].valor =
            this.$store.state.resultadodeducao.deducoes.icms[0].valor +
            this.$store.state.resultadodeducao.deducoes.piS_LR[0].valor +
            this.$store.state.resultadodeducao.deducoes.cofinS_LR[0].valor +
            this.$store.state.resultadodeducao.deducoes.iss[0].valor +
            this.$store.state.meses[i][5][0].valor +
            this.$store.state.meses[i][5][1].valor;
            }
        
      //calculando totais dos 2 campos do passo 7 <<

        
          this.$store.state.meses[i][6][9].valor = this.$store.state.meses[i][6][6].valor;

            this.$store.state.meses[i][6][7].valor =
            this.$store.state.meses[i][6][0].valor +
            this.$store.state.meses[i][6][1].valor -
            this.$store.state.meses[i][6][2].valor;
            this.$store.state.meses[i][6][8].valor =
            this.$store.state.meses[i][6][3].valor +
            this.$store.state.meses[i][6][4].valor -
            this.$store.state.meses[i][6][5].valor;
        
      
      //calculando totais dos 2 campos do passo 8 <<

       
          this.$store.state.meses[i][7][10].valor =
            this.$store.state.meses[i][7][0].valor +
            this.$store.state.meses[i][7][1].valor +
            this.$store.state.meses[i][7][2].valor +
            this.$store.state.meses[i][7][3].valor +
            this.$store.state.meses[i][7][4].valor +
            this.$store.state.meses[i][7][5].valor +
            this.$store.state.meses[i][7][6].valor +
            this.$store.state.meses[i][7][7].valor +
            this.$store.state.meses[i][7][8].valor +
            this.$store.state.meses[i][7][9].valor;
        
      
      //calculando totais dos 2 campos do passo 9 <<

       
           this.$store.state.meses[i][8][3].valor =
           this.$store.state.meses[i][8][1].valor * 0.08;
           this.$store.state.meses[i][8][4].valor =
           (this.$store.state.meses[i][8][0].valor +
              this.$store.state.meses[i][8][1].valor +
              this.$store.state.meses[i][8][2].valor) *
              0.2 +
            this.$store.state.meses[i][8][1].valor * 0.088;
            this.$store.state.meses[i][8][5].valor =
            this.$store.state.meses[i][8][0].valor +
            this.$store.state.meses[i][8][1].valor +
            this.$store.state.meses[i][8][2].valor +
            this.$store.state.meses[i][8][3].valor +
            this.$store.state.meses[i][8][4].valor;
        
      
      //calculando totais dos 2 campos do passo 12 <<


          this.$store.state.meses[i][11][10].valor =
            this.$store.state.meses[i][6][7].valor +
            this.$store.state.meses[i][6][8].valor +
            this.$store.state.meses[i][6][9].valor +
            this.$store.state.meses[i][7][10].valor +
            this.$store.state.meses[i][8][5].valor +
            this.$store.state.meses[i][11][9].valor;

            

          this.$store.state.meses[i][11][9].valor =
            this.$store.state.meses[i][9][0].valor +
            this.$store.state.meses[i][9][1].valor +
            this.$store.state.meses[i][9][2].valor +
            this.$store.state.meses[i][9][3].valor +
            this.$store.state.meses[i][9][4].valor +
            this.$store.state.meses[i][9][5].valor +
            this.$store.state.meses[i][9][6].valor +
            this.$store.state.meses[i][9][7].valor +
            this.$store.state.meses[i][9][8].valor +
            this.$store.state.meses[i][9][9].valor +
            this.$store.state.meses[i][10][0].valor +
            this.$store.state.meses[i][10][1].valor +
            this.$store.state.meses[i][10][2].valor +
            this.$store.state.meses[i][10][3].valor +
            this.$store.state.meses[i][10][4].valor +
            this.$store.state.meses[i][10][5].valor +
            this.$store.state.meses[i][10][6].valor +
            this.$store.state.meses[i][10][7].valor +
            this.$store.state.meses[i][10][8].valor +
            this.$store.state.meses[i][10][9].valor +
            this.$store.state.meses[i][11][0].valor +
            this.$store.state.meses[i][11][1].valor +
            this.$store.state.meses[i][11][2].valor +
            this.$store.state.meses[i][11][3].valor +
            this.$store.state.meses[i][11][4].valor +
            this.$store.state.meses[i][11][5].valor +
            this.$store.state.meses[i][11][6].valor +
            this.$store.state.meses[i][11][7].valor +
            this.$store.state.meses[i][11][8].valor;
        
    
      //calculando totais dos 2 campos do passo 13 <<

        
          this.$store.state.meses[i][12][18].valor =
            this.$store.state.meses[i][12][0].valor +
            this.$store.state.meses[i][12][1].valor +
            this.$store.state.meses[i][12][2].valor +
            this.$store.state.meses[i][12][3].valor +
            this.$store.state.meses[i][12][4].valor +
            this.$store.state.meses[i][12][5].valor +
            this.$store.state.meses[i][12][6].valor +
            this.$store.state.meses[i][12][7].valor +
            this.$store.state.meses[i][12][8].valor +
            this.$store.state.meses[i][12][9].valor +
            this.$store.state.meses[i][12][10].valor +
            this.$store.state.meses[i][12][11].valor +
            this.$store.state.meses[i][12][12].valor +
            this.$store.state.meses[i][12][13].valor +
            this.$store.state.meses[i][12][14].valor +
            this.$store.state.meses[i][12][15].valor +
            this.$store.state.meses[i][12][16].valor +
            this.$store.state.meses[i][12][17].valor;
        
      
      //calculando totais dos 2 campos do passo 14 <<

        
            this.$store.state.meses[i][13][12].valor =
            this.$store.state.meses[i][13][0].valor +
            this.$store.state.meses[i][13][1].valor +
            this.$store.state.meses[i][13][2].valor +
            this.$store.state.meses[i][13][3].valor +
            this.$store.state.meses[i][13][4].valor +
            this.$store.state.meses[i][13][5].valor +
            this.$store.state.meses[i][13][6].valor +
            this.$store.state.meses[i][13][7].valor +
            this.$store.state.meses[i][13][8].valor +
            this.$store.state.meses[i][13][9].valor +
            this.$store.state.meses[i][13][10].valor +
            this.$store.state.meses[i][13][11].valor;
    }

    },
    async avancarECF() {
      if (this.tipocontinuar == 1) {
        this.$store.state.ecf = 1;
        this.$store.state.step = 4;
        this.$store.state.chegouStepQuatro = true;
      }
      if (this.tipocontinuar == 2) {
        await this.fillReceita();
      }
    },

    
    async fillReceita(){
      console.log('-------------------')
      console.log(this.$store.state.api)
      console.log('-------------------')
      if(this.$store.state.importouEcf == true){
        if(this.$store.state.trimestral == true){
            for(let y = 0; y < this.$store.state.cnaeselecionados.length; y++){
          for(let i = 0; i < 12; i++){
            this.$store.state.meses[i][0].push({valor: this.$store.state.api[0][y].value[i]})
            this.$store.state.meses[i][1].push({valor: this.$store.state.api[1][y].value[i]})
            this.$store.state.meses[i][2].push({valor: this.$store.state.api[2][y].value[i]})
          }
        }
        }else{
        for(let y = 0; y < this.$store.state.cnaeselecionados.length; y++){
          for(let i = 0; i < 12; i++){
            this.$store.state.meses[i][0].push({valor: this.$store.state.api[0][y].value[i+1]})
            this.$store.state.meses[i][1].push({valor: this.$store.state.api[1][y].value[i+1]})
            this.$store.state.meses[i][2].push({valor: this.$store.state.api[2][y].value[i+1]})
          }
        }
        }
      }else{

      }
     
      

      console.log("começou a montar objeto")
      //MONTANDO O OBJETO QUE VAI RECEBER OS TOTAIS DE ACORDO COM O NUMERO DE CNAES SELECIONADOS <<
      for (var m = 0; m < 12; m++) {
        for (var s = 0; s < 3; s++) {
          for (var z = 0; z < this.$store.state.cnaeselecionados.length; z++) {
            if (this.totais[m][s].valor) {
              this.totais[m][s].valor = 0;
            } else {
              this.totais[m][s].push({ valor: 0 });
            }
          }
        }
      }
      //INSERINDO OS VALORES NO OBJETO CRIADO m = meses, s = mercado (direta, indireta etc...) z = input do cnae
      for (var m = 0; m < 12; m++) {
        for (var s = 0; s < 3; s++) {
          for (var z = 0; z < this.$store.state.cnaeselecionados.length; z++) {
              console.log(this.$store.state.meses[0][0])
              this.totais[m][s][z].valor += this.$store.state.meses[m][s][z].valor;
          }
        }
      }
       for (var i = 0; i < this.$store.state.cnaeselecionados.length; i++) {
         if(this.$store.state.trimestral == false){
           this.objetoCnae.push({
          cnae: this.$store.state.cnaeselecionados[i].cnae,
          irpj: this.$store.state.cnaeselecionados[i].p[0],
          csll: this.$store.state.cnaeselecionados[i].p[1],
          mercadoInterno: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][0][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][0][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][0][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][0][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][0][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][0][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][0][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][0][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][0][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][0][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][0][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][0][i].valor,
              },
            ],
          },
          mercadoExportacaoDireta: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][1][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][1][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][1][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][1][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][1][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][1][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][1][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][1][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][1][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][1][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][1][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][1][i].valor,
              },
            ],
          },
          mercadoExportacaoIndireta: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][2][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][2][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][2][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][2][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][2][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][2][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][2][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][2][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][2][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][2][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][2][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][2][i].valor,
              },
            ],
          },
        });
         }else{
          console.log(this.totais)
          this.objetoCnae.push({
          cnae: this.$store.state.cnaeselecionados[i].cnae,
          irpj: this.$store.state.cnaeselecionados[i].p[0],
          csll: this.$store.state.cnaeselecionados[i].p[1],
          mercadoInterno: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][0][i].valor,
              },
              {
                mes: 2,
                valor: 0,
              },
              {
                mes: 3,
                valor: 0,
              },
              {
                mes: 4,
                valor: this.totais[1][0][i].valor,
              },
              {
                mes: 5,
                valor: 0,
              },
              {
                mes: 6,
                valor: 0,
              },
              {
                mes: 7,
                valor: this.totais[2][0][i].valor,
              },
              {
                mes: 8,
                valor: 0,
              },
              {
                mes: 9,
                valor: 0,
              },
              {
                mes: 10,
                valor: this.totais[3][0][i].valor,
              },
              {
                mes: 11,
                valor: 0,
              },
              {
                mes: 12,
                valor: 0,
              },
            ],
          },
          mercadoExportacaoDireta: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][1][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][1][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][1][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][1][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][1][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][1][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][1][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][1][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][1][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][1][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][1][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][1][i].valor,
              },
            ],
          },
          mercadoExportacaoIndireta: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][2][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][2][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][2][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][2][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][2][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][2][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][2][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][2][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][2][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][2][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][2][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][2][i].valor,
              },
            ],
          },
        });
         }
        
      }


      console.log("terminou de montar objeto")
      console.log(this.objetoCnae)
      this.$store.state.envioCalculo[0] = this.objetoCnae;
      this.$store.state.envioCalculo[1] = this.selecestado;
      this.input();


      console.log("chamou envia mercados")
      console.log("chamou mercados2")

      await this.enviaMercados2();

      console.log("voltou de envia mercados2")
      console.log("começou a inserir deduções")

      //INSERINDO DEDUCOES RECEITA TODOS MESES
      if(this.$store.state.importouEcf == false){ 
      for (var y = 0; y < 12; y++) {
          if (this.$store.state.resultadodeducao.deducoes.icms.length > 1) {
            this.$store.state.meses[y][4].push({
              valor: this.$store.state.resultadodeducao.deducoes.icms[y].valor,
            });
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (this.$store.state.resultadodeducao.deducoes.piS_LR.length > 1) {
            this.$store.state.meses[y][4].push({
              valor: this.$store.state.resultadodeducao.deducoes.piS_LR[y]
                .valor,
            });
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (
            this.$store.state.resultadodeducao.deducoes.cofinS_LR.length > 1
          ) {
            this.$store.state.meses[y][4].push({
              valor: this.$store.state.resultadodeducao.deducoes.cofinS_LR[y]
                .valor,
            });
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (this.$store.state.resultadodeducao.deducoes.piS_LP.length > 1) {
            this.$store.state.meses[y][4].push({
              valor: this.$store.state.resultadodeducao.deducoes.piS_LP[y]
                .valor,
            });
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (
            this.$store.state.resultadodeducao.deducoes.cofinS_LP.length > 1
          ) {
            this.$store.state.meses[y][4].push({
              valor: this.$store.state.resultadodeducao.deducoes.cofinS_LP[y]
                .valor,
            });
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (this.$store.state.resultadodeducao.deducoes.iss.length > 1) {
            this.$store.state.meses[y][4].push({
              valor: this.$store.state.resultadodeducao.deducoes.iss[y].valor,
            });
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
      }
      }else{
        if(this.$store.state.presumido == false){
          for (var y = 0; y < 12; y++) {
              if (this.$store.state.resultadodeducao.deducoes.piS_LP.length > 1) {
                this.$store.state.meses[y][4][3].valor = this.$store.state.resultadodeducao.deducoes.piS_LP[y].valor;
              } else {
                this.$store.state.meses[y][4].push({ valor: 0 });
              }
              if (this.$store.state.resultadodeducao.deducoes.cofinS_LP.length > 1) {
                this.$store.state.meses[y][4][4].valor = this.$store.state.resultadodeducao.deducoes.cofinS_LP[y].valor;
              } else {
                this.$store.state.meses[y][4].push({ valor: 0 });
              }
          }   
        }else{
          for (var y = 0; y < 12; y++) {
              if (this.$store.state.resultadodeducao.deducoes.piS_LR.length > 1) {
                this.$store.state.meses[y][4][1].valor = this.$store.state.resultadodeducao.deducoes.piS_LR[y].valor;
              } else {
                this.$store.state.meses[y][4].push({ valor: 0 });
              }
              if (this.$store.state.resultadodeducao.deducoes.cofinS_LR.length > 1) {
                this.$store.state.meses[y][4][2].valor = this.$store.state.resultadodeducao.deducoes.cofinS_LR[y].valor;
              } else {
                this.$store.state.meses[y][4].push({ valor: 0 });
              }
          }   
        }
              
      }

      this.carregando = false;
      this.input();
      this.$store.state.chegouMonthStepQuatro = true,
      this.$store.state.chegouStepQuatro = true,
      this.$store.state.step = 5


  

    },
    async avancar() {
      // >>>>>>> AVANÇAR >>>>>>

      if(this.$store.state.trimestral == true){
         if (this.$store.state.step == 1) {
        if (this.tiposimulacao == 2) {
          this.$store.state.ecf = 2;
        } else {
          this.$store.state.ecf = 1;
        }
      }
      if (this.$store.state.step == 2) {
        if (this.$store.state.cnaeselecionados.length == 0) {
          return;
        }
        this.$store.state.month = 1;
        this.$store.state.monthstep = 1;
      }
      if (this.$store.state.step == 3) {
        if (this.selecestado == "0") {

          return;
        }
        this.$store.state.month = 1;
        this.$store.state.monthstep = 1;
      }
      if (this.$store.state.step == 4) {
        if (this.$store.state.month >= 4) {
          if (this.$store.state.monthstep == 3) {
            console.log('vindo')
            this.inputSpinner = true;
            this.montaobjeto(1);
            this.enviaMercados();
            this.inputSpinner = false;
            this.$store.state.chegouMonthStepQuatro = true;
            this.$store.state.month = 1;
          }
          if (this.$store.state.monthstep == 11) {
            this.input();
          }
          if (this.$store.state.monthstep == 14) {
            this.calcular();
          }
          this.$store.state.month = 1;
          this.$store.state.monthstep += 1;
        } else {
          this.$store.state.month += 1;
        }
        // this.somar();
      } else {
        this.$store.state.step += 1;
        window.scrollTo(0, 160);
      }
        
      }else{
         if (this.$store.state.step == 1) {
        if (this.tiposimulacao == 2) {
          this.$store.state.ecf = 2;
        } else {
          this.$store.state.ecf = 1;
        }
      }
      if (this.$store.state.step == 2) {
        if (this.$store.state.cnaeselecionados.length == 0) {
          return;
        }
        this.$store.state.month = 1;
        this.$store.state.monthstep = 1;
      }
      if (this.$store.state.step == 3) {
        if (this.selecestado == "0") {
          return;
        }
        console.log("chegoustepquatro")
        this.$store.state.chegouStepQuatro = true;
        this.$store.state.month = 1;
        this.$store.state.monthstep = 1;
      }
      if (this.$store.state.step == 4) {
        if (this.$store.state.month >= 12) {
          if (this.$store.state.monthstep == 3) {
            this.inputSpinner = true;
            await this.cleaner();
            this.setter();
            this.$store.state.chegouMonthStepQuatro = true;
            this.inputSpinner = false;
            this.$store.state.month = 1;
            this.input();
          }
          if (this.$store.state.monthstep == 11) {
            this.input();
          }
          if (this.$store.state.monthstep == 14) {
            this.calcular();
            this.$store.state.step = 5
          }
          this.$store.state.month = 1;
          this.$store.state.monthstep += 1;
        } else {
          this.$store.state.month += 1;
        }
        // this.somar();
      } else {
        this.$store.state.step += 1;
        window.scrollTo(0, 160);
      }
      }
    },

    voltar() {
      // >>>>>>> VOLTAR >>>>>>
      if(this.$store.state.trimestral == true){
        if (this.$store.state.step <= 1) {
        this.$store.state.step = 1;
      } else {
        if (this.$store.state.step == 4 && this.$store.state.month == 1) {
          if (this.$store.state.monthstep == 1) {
            this.$store.state.step -= 1;
            window.scrollTo(0, 160);
          } else {
            this.$store.state.monthstep -= 1;
            this.$store.state.month = 4;
          }
        } else {
          if (this.$store.state.step != 4) {
            this.$store.state.step -= 1;
            window.scrollTo(0, 160);
          } else {
            this.$store.state.month -= 1;
          }
        }
      }
      }else{
        if (this.$store.state.step <= 1) {
        this.$store.state.step = 1;
      } else {
        if (this.$store.state.step == 4 && this.$store.state.month == 1) {
          if (this.$store.state.monthstep == 1) {
            this.$store.state.step -= 1;
            window.scrollTo(0, 160);
          } else {
            this.$store.state.monthstep -= 1;
            this.$store.state.month = 12;
          }
        } else {
          if (this.$store.state.step != 4) {
            this.$store.state.step -= 1;
            window.scrollTo(0, 160);
          } else {
            this.$store.state.month -= 1;
          }
        }
      }
      }

      
    },
    cleaner(){
    if(this.$store.state.api[3].length){
      this.$store.state.api[3].splice(0, this.$store.state.api[3].length);
    }
    for(let i = 0; i < 12; i++){
      if(this.$store.state.meses[i][3].length){
        this.$store.state.meses[i][3] = []
      } 
    }
    console.log("cleanado")
    },
    setter(){
    this.montaobjeto();
    this.enviaMercados();
    console.log("settado")
    },

    async buscarCNAE() {
      // metodo que busca o CNAE ao clicar em Buscar
      let resultadocnaee = await api.buscarCNAE(this.cnae);
      if (resultadocnaee == undefined) {
        this.$modal.show("errocnae");
      } else {
        this.resultadocnae = resultadocnaee;
      }
    },

    async buscarCNAEECF(cnae){
      let resultadocnaee = await api.buscarCNAE(cnae);
      if (resultadocnaee == undefined) {
        return undefined
      } else {
        return resultadocnaee;
      }
    },

    adicionar(cnae, descricao, n) {
      //Chamado quando o botão adicionar dos cnaes é clicado
      if (this.resultadocnae[n].excecao != "") {
        this.excecaoAtual = this.resultadocnae[n].excecao;
        this.$modal.show("excecao");
      } else {
        if (this.$store.state.cnaeselecionados.length < 3) {
          this.cnaeextenso = { cnae: cnae, descricao: descricao };
          if (this.resultadocnae[n].pergunta == null) {
            this.adicionarTT(
              this.resultadocnae[n].irpj,
              this.resultadocnae[n].csll
            );
          } else {
            this.atualPergunta = this.resultadocnae[n].pergunta;
            this.$modal.show("adicionar");
          }
        }
      }
    },

    adicionarTT(irpj, csll) {
      let p1;
      let p2;
      p1 = irpj;
      p2 = csll;
      //Chamado quando o botão adicionar da MODAL dos cnaes é clicado, retornando a porcentagem selecionada
      this.$store.state.cnaeselecionados.push({
        cnae: this.cnaeextenso.cnae,
        descricao: this.cnaeextenso.descricao,
        p: [p1, p2],
      });
      for (var i = 0; i < 3; i++) {
        this.$store.state.api[i].push({
          titulo: `${this.cnaeextenso.cnae} - ${this.cnaeextenso.descricao}`,
          cnae: this.cnaeextenso.cnae,
          info: "",
        });
      }
      this.setaInfoReceita();
      this.$modal.hide("adicionar");
    },

    adicionarTTECF(irpj, csll, cnae) {
      let p1;
      let p2;
      p1 = irpj;
      p2 = csll;
      //Chamado quando o botão adicionar da MODAL dos cnaes é clicado, retornando a porcentagem selecionada
      this.$store.state.cnaeselecionados.push({
        cnae: cnae.cnae,
        descricao: cnae.descricao,
        p: [p1, p2],
      });
      for (var i = 0; i < 3; i++) {
        this.$store.state.api[i].push({
          titulo: `${ cnae.cnae } - ${ cnae.descricao }`,
          cnae: cnae.cnae,
          info: "",
          value: []
        });
      }
      this.setaInfoReceita();
      this.$modal.hide("adicionar");
    },

    remover(cnae, descricao, n) {
      //Chamado quando o botão remover dos cnaes é clicado
      this.$store.state.chegouStepQuatro = false;
      var removeIndex = this.$store.state.cnaeselecionados
        .map(function (item) {
          return item.cnae;
        })
        .indexOf(cnae);
      var removeIndex2 = this.$store.state.api[0]
        .map(function (item) {
          return item.cnae;
        })
        .indexOf(cnae);
      this.$store.state.cnaeselecionados.splice(removeIndex, 1);
      this.$store.state.api[0].splice(removeIndex2, 1);
      this.$store.state.api[1].splice(removeIndex2, 1);
      this.$store.state.api[2].splice(removeIndex2, 1);
    },

    emitGlobalClickEvent() {
      // emite REPLICAR para o EVENTBUS
      EventBus.$emit("replicar", this.mesreplicar, this.$store.state.month);
      this.mesreplicar = 0;
    },

    //MONTA OBJETO COM TOTAIS DOS MERCADOS <<
    montaobjeto(tipo) {
      //MONTANDO O OBJETO QUE VAI RECEBER OS TOTAIS DE ACORDO COM O NUMERO DE CNAES SELECIONADOS <<

      this.totais = [
        //variavel que guarda a soma de cada mercado para cada mes
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
        [[], [], []],
      ]

      for (var m = 0; m < 12; m++) {
        for (var s = 0; s < 3; s++) {
          for (var z = 0; z < this.$store.state.cnaeselecionados.length; z++) {
            if (this.totais[m][s].valor) {
              this.totais[m][s].valor = 0;
            } else {
              this.totais[m][s].push({ valor: 0 });
            }
          }
        }
      }

      //INSERINDO OS VALORES NO OBJETO CRIADO m = meses, s = mercado (direta, indireta etc...) z = input do cnae
      
      for (var m = 0; m < 12; m++) {
        for (var s = 0; s < 3; s++) {
          for (var z = 0; z < this.$store.state.cnaeselecionados.length; z++) {
              console.log(this.$store.state.meses[m][s][z].valor)
              this.totais[m][s][z].valor += this.$store.state.meses[m][s][z].valor;
          }
        }
      }
      this.montaobjetoReceitas();
    },

    //MONTA OBJETO DAS RECEITAS <<
    montaobjetoReceitas() {
      console.log(this.totais)
      this.objetoCnae = [];
      for (var i = 0; i < this.$store.state.cnaeselecionados.length; i++) {
        this.objetoCnae.push({
          cnae: this.$store.state.cnaeselecionados[i].cnae,
          irpj: this.$store.state.cnaeselecionados[i].p[0],
          csll: this.$store.state.cnaeselecionados[i].p[1],
          mercadoInterno: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][0][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][0][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][0][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][0][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][0][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][0][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][0][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][0][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][0][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][0][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][0][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][0][i].valor,
              },
            ],
          },
          mercadoExportacaoDireta: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][1][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][1][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][1][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][1][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][1][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][1][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][1][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][1][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][1][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][1][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][1][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][1][i].valor,
              },
            ],
          },
          mercadoExportacaoIndireta: {
            receita: [
              {
                mes: 1,
                valor: this.totais[0][2][i].valor,
              },
              {
                mes: 2,
                valor: this.totais[1][2][i].valor,
              },
              {
                mes: 3,
                valor: this.totais[2][2][i].valor,
              },
              {
                mes: 4,
                valor: this.totais[3][2][i].valor,
              },
              {
                mes: 5,
                valor: this.totais[4][2][i].valor,
              },
              {
                mes: 6,
                valor: this.totais[5][2][i].valor,
              },
              {
                mes: 7,
                valor: this.totais[6][2][i].valor,
              },
              {
                mes: 8,
                valor: this.totais[7][2][i].valor,
              },
              {
                mes: 9,
                valor: this.totais[8][2][i].valor,
              },
              {
                mes: 10,
                valor: this.totais[9][2][i].valor,
              },
              {
                mes: 11,
                valor: this.totais[10][2][i].valor,
              },
              {
                mes: 12,
                valor: this.totais[11][2][i].valor,
              },
            ],
          },
        });
      }
      console.log(this.$store.state.cnaeselecionados)
    },

    async enviaMercados2() {
      // enviaMercados2() é chamado quando o cliente vai para o step 4, para calcular os mercados enviados

      this.carregando = true;
      this.$store.state.resultadodeducao = await api.enviaMercados(
        this.objetoCnae,
        this.selecestado,
        this.iss
      );

      //INSERINDO OS INPUTS DE ACORDO COM OS CNAES SELECIONADO
      console.log("Inserindo inputs")
      for (
        var i = 0;
        i < this.$store.state.resultadodeducao.receitaBruta.length;
        i++
      ) {
        this.$store.state.api[3].push({
          titulo: this.$store.state.resultadodeducao.receitaBruta[i].nome,
          input: false,
          info: "",
        });
      }
      console.log("Inserindo total")
      //INSERINDO O INPUT DO TOTAL
      this.$store.state.api[3].push({
        titulo: "TOTAL DA RECEITA BRUTA AUFERIDA NO MÊS",
        input: false,
        info: "",
      });

      console.log("terminou enviaMercado2")
    },
    async enviaMercados2() {
      // enviaMercados2() é chamado quando o cliente vai para o step 4, para calcular os mercados enviados

      this.carregando = true;
      this.$store.state.resultadodeducao = await api.enviaMercados(
        this.objetoCnae,
        this.selecestado,
        this.iss
      );
      console.log('----------------')
      console.log(this.$store.state.resultadodeducao)
      console.log('----------------')
      //INSERINDO OS INPUTS DE ACORDO COM OS CNAES SELECIONADO
      
      for (
        var i = 0;
        i < this.$store.state.resultadodeducao.receitaBruta.length;
        i++
      ) {
        this.$store.state.api[3].push({
          titulo: this.$store.state.resultadodeducao.receitaBruta[i].nome,
          input: false,
          info: "",
        });
      }
      
      //INSERINDO O INPUT DO TOTAL
      this.$store.state.api[3].push({
        titulo: "TOTAL DA RECEITA BRUTA AUFERIDA NO MÊS",
        input: false,
        info: "",
      });

      console.log("terminou enviaMercado2")
    },
    async enviaMercados() {
      // enviaMercados() é chamado quando o cliente vai para o step 4, para calcular os mercados enviados
      console.log("chamou mercados2")
      await this.enviaMercados2();
      console.log("voltou de envia mercados2")
      //INSERINDO RECEITA BRUTA EM TODOS MESES

      for (var i = 0; i < this.$store.state.resultadodeducao.receitaBruta.length; i++) {
        for (
          var z = 0;
          z < this.$store.state.resultadodeducao.receitaBruta[i].receita.length;
          z++
        ) {
            this.$store.state.meses[z][3][i].valor = this.$store.state.resultadodeducao.receitaBruta[i].receita[z].valor;
            if (i == this.$store.state.resultadodeducao.receitaBruta.length - 1) {
              var soma = 0;
              for (var l = 0; l < this.$store.state.resultadodeducao.receitaBruta.length;l++) {
                soma += this.$store.state.resultadodeducao.receitaBruta[l].receita[z].valor;
              }
                this.$store.state.meses[z][3][this.$store.state.resultadodeducao.receitaBruta.length].valor = soma;
            }
        }
      }
      console.log(this.$store.state.resultadodeducao.deducoes)
      //INSERINDO DEDUCOES RECEITA TODOS MESES
      if(this.$store.state.importouEcf == false){ 
      for (var y = 0; y < 12; y++) {
          if (this.$store.state.resultadodeducao.deducoes.icms.length > 1) {
            this.$store.state.meses[y][4][0].valor = this.$store.state.resultadodeducao.deducoes.icms[y].valor
          } else {
            this.$store.state.meses[y][4][0].valor = 0
          }
          if (this.$store.state.resultadodeducao.deducoes.piS_LR.length > 1) {
            this.$store.state.meses[y][4][1].valor = this.$store.state.resultadodeducao.deducoes.piS_LR[y].valor
          } else {
            this.$store.state.meses[y][4][1].valor = 0
          }
          if (
            this.$store.state.resultadodeducao.deducoes.cofinS_LR.length > 1
          ) {
            this.$store.state.meses[y][4][2].valor = this.$store.state.resultadodeducao.deducoes.cofinS_LR[y].valor
          } else {
            this.$store.state.meses[y][4][2].valor = 0
          }
          if (this.$store.state.resultadodeducao.deducoes.piS_LP.length > 1) {
            this.$store.state.meses[y][4][3].valor = this.$store.state.resultadodeducao.deducoes.piS_LP[y].valor
          } else {
            this.$store.state.meses[y][4][3].valor = 0
          }
          if (
            this.$store.state.resultadodeducao.deducoes.cofinS_LP.length > 1
          ) {
            this.$store.state.meses[y][4][4].valor = this.$store.state.resultadodeducao.deducoes.cofinS_LP[y].valor
          } else {
            this.$store.state.meses[y][4][4].valor = 0
          }
          if (this.$store.state.resultadodeducao.deducoes.iss.length > 1) {
            this.$store.state.meses[y][4][5].valor = this.$store.state.resultadodeducao.deducoes.iss[y].valor
          } else {
            this.$store.state.meses[y][4][5].valor = 0
          }
      }
      }else{
        if(this.$store.state.presumido == false){
          for (var y = 0; y < 12; y++) {
          if (this.$store.state.resultadodeducao.deducoes.piS_LP.length > 1) {
            this.$store.state.meses[y][4][3].valor = this.$store.state.resultadodeducao.deducoes.piS_LP[y].valor;
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (this.$store.state.resultadodeducao.deducoes.cofinS_LP.length > 1) {
            this.$store.state.meses[y][4][4].valor = this.$store.state.resultadodeducao.deducoes.cofinS_LP[y].valor;
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
       }
        }else{
          for (var y = 0; y < 12; y++) {
          if (this.$store.state.resultadodeducao.deducoes.piS_LR.length > 1) {
            this.$store.state.meses[y][4][1].valor = this.$store.state.resultadodeducao.deducoes.piS_LR[y].valor;
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
          if (this.$store.state.resultadodeducao.deducoes.cofinS_LR.length > 1) {
            this.$store.state.meses[y][4][2].valor = this.$store.state.resultadodeducao.deducoes.cofinS_LR[y].valor;
          } else {
            this.$store.state.meses[y][4].push({ valor: 0 });
          }
       }
        }
      }

      this.carregando = false;
      
    },

    calcular() {
      //Chamado quando o cliente passar do ultimo step
      let objetoMeses = this.$store.state.meses;
      this.$store.state.envioCalculo.push(this.objetoCnae);
      this.$store.state.envioCalculo.push(this.selecestado);
      // this.$store.state.step = 5;
    },
  },
};
</script>

<style>
.error {
  background: red !important;
}

input[type="file"] {
  display: none;
}

.label2 {
  font-size:15px;
  color:rgb(0,0,0,0.50);
}

.label {
  margin-bottom: 0 !important;
  padding-top: 7px !important;
  vertical-align: middle !important;
  margin-top: 0px !important;
  width: 140px;
  height: 48px;
  margin: 10px;
  background: #af3437 !important;
  color: white !important;
  border-radius: 5px;
  text-align: center !important;
  font-size: 20px !important;
  font-weight: 600;
  font-style: italic;
  margin-bottom: 130px;
}

.label:hover {
  background: #943335 !important;
}

.nav-bar {
  margin: 20px auto;
  background: #eeeeee;
  width: 100%;
  height: 30px;
}

.nav-bar p {
  margin: 10px 0 0 10px !important;
  padding: 3px 0 0 10px;
}

.large-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 70px !important;
  background: #eeeeee;
  max-width: 600px;
  border-radius: 5px;
  padding: 25px;
}

.large-bar::before {
  position: relative;
  content: "";
  background: #af3437;
  height: 70px;
  left: -25px;
  width: 7px;
  border-radius: 5px 0 0 5px;
}

.large-bar-radio {
  margin: 0 30px 0 20px;
}

.large-bar p {
  padding: 15px 0 0 0;
}

/* .large-bar p:before {
  font-family: "Font Awesome 5 Free";
  content: "\f111";
  display: inline-block;
  vertical-align: middle;
  font-weight: 900;
  color: #af3437;
  padding-right: 30px;
} */

select {
  position: relative;
  outline: none;
  padding-left: 10px;
  max-width: 200px;
  height: 38px;
  background: 0% 0% no-repeat padding-box padding-box rgb(255, 255, 255);
  border: 1px solid rgb(187, 187, 187);
  border-radius: 5px;
  cursor: pointer;
}

.input-iss {
  position: relative;
  outline: none;
  padding-left: 10px;
  max-width: 200px;
  height: 38px;
  background: 0% 0% no-repeat padding-box padding-box rgb(255, 255, 255);
  border: 1px solid rgb(187, 187, 187);
  border-radius: 5px;
}

.input-primary {
  max-width: 533px !important;
  height: 35px !important;
  padding-right: 50px;
  margin-right: -36px;
  padding-top: 10px;
}

.notaexplicativa {
  margin-top: 20px;
  width: 100%;
  background: #ffe6e6;
  min-height: 37px;
}

.table-cnae {
  width: 100%;
}

.table-cnae tr {
  width: 100%;
}

.table-cnae th {
  width: 100%;
}

.table-cnae td {
  width: 80% !important;
  text-align: left;
}

.table-meses tr {
  width: 100%;
}

#menu ul li {
  display: inline;
}

.black-bar {
  width: 100%;
  border-bottom: 0.6px solid #555;
}

.month-bar {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: #eeeeee;
  min-height: 60px;
  margin-top: 15px;
  width: 100%;
}

.replicar {
  display: flex;
  align-items: center;
  flex-direction: row;
}

.buttons {
  display: block;
}

.replicar-btn {
  margin-top: 25px;
  margin-left: 25px;
  width: 140px;
  height: 35px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  font-style: italic;
}

.replicar-btn:hover {
  background: #943335;
}

.adicionar-btn {
  margin-left: 10px;
  width: 140px;
  height: 20px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 600;
  font-style: italic;
}

.adicionar-btn:hover {
  background: #943335;
}

.continuar-btn {
  margin-top: 100px !important;
  width: 140px;
  height: 48px;
  margin: 10px;
  color: #fff;
  background: #af3437;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 600;
  font-style: italic;
  margin-bottom: 20px;
}

.continuar-sem-btn {
  margin-top: 25px !important;
  width: 140px;
  height: 48px;
  margin: 10px;
  border: 1px solid #af3437;
  color: #af3437;
  border-radius: 5px;
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
  margin-bottom: 20px;
}

.continuar-btn:hover {
  background: #943335;
}

.voltar-btn {
  margin-top: 100px !important;
  width: 140px;
  height: 48px;
  margin: 10px;
  color: #383838;
  border-radius: 5px;
  font-size: 20px;
  font-weight: 600;
  font-style: italic;
  margin-bottom: 20px;
}

.active-month {
  border-bottom: #af3437 solid 4px;
}
</style>